<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path v-for="(path, index) in paths[name] || paths.camera" :key="index" :d="path" />
  </svg>
</template>
<script setup lang="ts">
defineProps<{ name: string }>();
const paths: Record<string, string[]> = {
  home: ['M3 10.5L12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1v-9.5z'],
  recordings: [
    'M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z',
    'm10 9 5 3-5 3z',
  ],
  settings: [
    'M4 7h2m6 0h8M4 17h8m6 0h2',
    'M12 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0M18 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
  ],
  camera: ['M3 6h12v12H3zM15 10l6-4v12l-6-4'],
  expand: [
    'M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3',
  ],
  close: ['m6 6 12 12M6 18 18 6'],
  back: ['m15 18-6-6 6-6'],
  play: ['m8 5 11 7-11 7z'],
  pause: ['M8 5v14M16 5v14'],
  previous: ['m11 6-8 6 8 6V6zm10 0-8 6 8 6V6z'],
  next: ['m3 6 8 6-8 6V6zm10 0 8 6-8 6V6z'],
  sun: [
    'M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5',
  ],
  moon: ['M20 15.5A9 9 0 0 1 8.5 4a9 9 0 1 0 11.5 11.5Z'],
  download: ['M12 3v12m-4-4 4 4 4-4M4 16v4h16v-4'],
  snapshot: ['M4 6h4l2-3h4l2 3h4v14H4z', 'M16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0'],
  calendar: [
    'M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM16 2v4M8 2v4M3 10h18',
  ],
  folder: ['M3 6a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'],
  reset: ['M3 10a9 9 0 1 1 1 8M3 4v6h6'],
};
</script>
